import React, { useState } from "react"
import Head from "next/head"
import { Container, Card, Row } from "react-bootstrap"

import MiscHeroImage from "@/main/miscHeroImage"
import EmployeeCard from "@/ourTeam/employeeCard.js"

function OurTeamScreen() {
    const url = "https://webbjenkins.co.uk/our-team/"
    const title = "Meet Our Team - Webb Jenkins"
    const description =
        "Meet our team of experienced estate & lettings agents at Webb Jenkins. We are here to resolve all of your property needs across the Isle of Wight."
    const imgUrl =
        "https://webb-jenkins-static-164679926.imgix.net/socials/webbjenkins-team-social.jpg"
    const imgWidth = 1200
    const imgHeight = 630
    const imgAlt = "Webb Jenkins logo with meet our team caption"

    return (
        <>
            <Head>
                <link rel="canonical" href={url} />
                <title>{title}</title>
                <meta name="description" content={description} />

                <meta property="fb:app_id" content="362437448786240" />
                <meta property="og:title" content={title} />
                <meta property="og:image:url" content={imgUrl} />
                <meta property="og:image:width" content={imgWidth} />
                <meta property="og:image:height" content={imgHeight} />
                <meta property="og:image:alt" content={imgAlt} />
                <meta property="og:description" content={description} />
                <meta property="og:url" content={url} />
                <meta property="og:type" content="website" />
                <meta property="og:locale" content="en" />

                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:image:src" content={imgUrl} />
                <meta name="twitter:site" content="@WebbJenkinsIOW" />
            </Head>

            <MiscHeroImage
                title="Our team"
                subtitle="At the heart of our business are our employees. Ready to go above and beyond to deliver the exceptional service you deserve"
                image="office-teamwork.jpg"
                alt="Team of employees putting their hands together in the center of a circle to show teamwork"
                position="center"
            />
            <Container fluid className="card-overlap-2 px-0">
                <Container fluid="md" as={Card}>
                    <Card.Body>
                        <Card.Title>
                            <h2 className="text-center">Who we are</h2>
                        </Card.Title>
                    </Card.Body>
                </Container>
                <Container fluid="md" as={Card} className="p-0 mt-4">
                    <Card.Body>
                        <Card.Text className="text-center">
                            <span>
                                Webb Jenkins was established by Steve Webb and
                                Mark Jenkins and has been trading successfully
                                since 1998. In this time we have firmly
                                established ourselves as one of the Isle of
                                Wight&apos;s leading estate agencies. You will
                                find our office in Ventnor, however we operate
                                across the Island. We now have vast experience
                                in the local market, enabling us to provide our
                                clients with an impeccable service. We pride
                                ourselves on providing an honest service and
                                making all aspects of our business easy and
                                accessible to everyone. We frequently involve
                                ourselves with the local community, including
                                charities and businesses, which in turn has made
                                us many friends and clients over the years.
                            </span>
                        </Card.Text>
                    </Card.Body>
                </Container>
                <Container fluid="md" as={Card} className="mt-5">
                    <Card.Body>
                        <Card.Title>
                            <h2 className="text-center">Meet the team</h2>
                        </Card.Title>
                    </Card.Body>
                </Container>

                <div className="mt-4 d-block d-md-none">
                    <EmployeeCard
                        name="Steve Webb"
                        image="steve.jpg"
                        alt="Steve Webb, member of the Webb Jenkins team"
                        direction="left"
                    />

                    <EmployeeCard
                        name="Mark Jenkins"
                        image="mark.jpg"
                        alt="Mark Jenkins, member of the Webb Jenkins team"
                        direction="right"
                    />

                    <EmployeeCard
                        name="Olivia Jenkins"
                        image="olivia.jpg"
                        alt="Olivia Jenkins, member of the Webb Jenkins team"
                        direction="left"
                    />

                    {/* <EmployeeCard
                        name="Beckie Aubert"
                        image="beckie.jpg"
                        alt="Beckie Aubert, member of the Webb Jenkins team"
                        direction="right"
                    /> */}
                </div>
                <div className="mt-4 d-none d-md-block">
                    <Container fluid="md" className="px-3">
                        <Row>
                            <EmployeeCard
                                name="Steve Webb"
                                image="steve.jpg"
                                alt="Steve Webb, member of the Webb Jenkins team"
                                direction="left"
                            />
                            <EmployeeCard
                                name="Mark Jenkins"
                                image="mark.jpg"
                                alt="Mark Jenkins, member of the Webb Jenkins team"
                                direction="left"
                            />
                        </Row>

                        <Row>
                            <EmployeeCard
                                name="Olivia Jenkins"
                                image="olivia.jpg"
                                alt="Olivia Jenkins, member of the Webb Jenkins team"
                                direction="right"
                            />
                            {/* <EmployeeCard
                                name="Beckie Aubert"
                                image="beckie.jpg"
                                alt="Beckie Aubert, member of the Webb Jenkins team"
                                direction="right"
                            /> */}
                        </Row>
                    </Container>
                </div>
            </Container>
        </>
    )
}

export default OurTeamScreen
